export default __webpack_public_path__ + "static/media/XEMP-10.9c881027.jpg";